document.addEventListener('DOMContentLoaded', function () {
  var drawer = document.getElementById('mobile-menu');
  if (!drawer) return;

  var announcement = document.querySelector('.announcement-bar-section');

  function updateVisibleAnnouncementHeight() {
    var visibleHeight = 0;

    if (announcement) {
      var rect = announcement.getBoundingClientRect();
      visibleHeight = Math.max(0, Math.min(rect.height, rect.bottom));
    }

    document.documentElement.style.setProperty('--bs-announcement-height', Math.ceil(visibleHeight) + 'px');
  }

  var viewportStyle = document.createElement('style');
  viewportStyle.id = 'blacksmith-mobile-menu-sticky-viewport-fix';
  viewportStyle.textContent =
    '@media only screen and (max-width:1067px){' +
      '.blacksmith-menu-viewport-ancestor{' +
        'overflow:visible!important;max-height:none!important;clip-path:none!important;contain:none!important;transform:none!important;' +
      '}' +
      '#mobile-menu.blacksmith-mobile-menu.active{' +
        'position:fixed!important;inset:var(--bs-announcement-height,0px) 0 0 0!important;width:100vw!important;' +
        'height:calc(100vh - var(--bs-announcement-height,0px))!important;' +
        'min-height:calc(100vh - var(--bs-announcement-height,0px))!important;' +
      '}' +
      '@supports(height:100dvh){#mobile-menu.blacksmith-mobile-menu.active{' +
        'height:calc(100dvh - var(--bs-announcement-height,0px))!important;' +
        'min-height:calc(100dvh - var(--bs-announcement-height,0px))!important;' +
      '}}' +
    '}';
  document.head.appendChild(viewportStyle);

  var ancestors = [];
  var node = drawer.parentElement;
  while (node && node !== document.body) {
    ancestors.push(node);
    node = node.parentElement;
  }

  function syncAncestorState() {
    var isOpen = drawer.classList.contains('active');
    ancestors.forEach(function (ancestor) {
      ancestor.classList.toggle('blacksmith-menu-viewport-ancestor', isOpen);
    });
    updateVisibleAnnouncementHeight();
  }

  updateVisibleAnnouncementHeight();
  syncAncestorState();
  window.addEventListener('scroll', updateVisibleAnnouncementHeight, { passive: true });
  window.addEventListener('resize', updateVisibleAnnouncementHeight, { passive: true });

  var viewportObserver = new MutationObserver(syncAncestorState);
  viewportObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
});

document.addEventListener('DOMContentLoaded', function () {
  var drawer = document.getElementById('mobile-menu');
  if (!drawer) return;

  var exploreCards = [
    {
      title: 'What Size Wheel Bag Do I Need?',
      url: '/blogs/bs-blog/what-size-4wd-wheel-bag-do-i-need',
      image: 'https://cdn.shopify.com/s/files/1/0257/3464/3774/articles/Aus-Made-Wheel-Bag-79-Series_f9150391-ec2a-45f1-bdbe-6e01dff75664_1000x750.jpg?v=1783738684'
    },
    {
      title: 'Australian Canvas Vs. Overseas Canvas',
      url: '/blogs/bs-blog/australian-canvas-vs-overseas-canvas',
      image: 'https://cdn.shopify.com/s/files/1/0257/3464/3774/articles/BS-Blog-Header2_1000x750.jpg?v=1621083613'
    }
  ];

  if (!document.getElementById('blacksmith-mobile-explore-card-styles')) {
    var exploreStyle = document.createElement('style');
    exploreStyle.id = 'blacksmith-mobile-explore-card-styles';
    exploreStyle.textContent =
      '@media only screen and (max-width:1067px){' +
        '.blacksmith-mobile-menu__explore-grid-item{display:block!important;margin:0!important;padding:0!important;}' +
        '.blacksmith-mobile-menu__explore-grid{' +
          'display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:10px!important;padding:0 0 18px!important;' +
        '}' +
        '.blacksmith-mobile-menu__explore-card{' +
          'position:relative!important;display:block!important;min-height:132px!important;overflow:hidden!important;' +
          'border-radius:10px!important;background-color:#27292a!important;background-position:center!important;' +
          'background-size:cover!important;color:#fff!important;isolation:isolate!important;' +
        '}' +
        '.blacksmith-mobile-menu__explore-card:after{' +
          'content:""!important;position:absolute!important;inset:0!important;z-index:-1!important;' +
          'background:linear-gradient(to top,rgba(0,0,0,.76),rgba(0,0,0,.06) 72%)!important;' +
        '}' +
        '.blacksmith-mobile-menu__explore-card-copy{' +
          'position:absolute!important;right:11px!important;bottom:11px!important;left:11px!important;display:block!important;' +
        '}' +
        '.blacksmith-mobile-menu__explore-card-eyebrow{' +
          'display:block!important;margin:0 0 4px!important;color:rgba(255,255,255,.78)!important;' +
          'font-size:.65rem!important;font-weight:var(--font-body-bold-weight,600)!important;' +
          'letter-spacing:.055em!important;line-height:1!important;text-transform:uppercase!important;' +
        '}' +
        '.blacksmith-mobile-menu__explore-card-title-row{' +
          'display:flex!important;align-items:baseline!important;justify-content:flex-start!important;gap:6px!important;' +
        '}' +
        '.blacksmith-mobile-menu__explore-card-title,' +
        '.blacksmith-mobile-menu__explore-card-arrow{' +
          'color:#fff!important;font-size:.9rem!important;font-weight:var(--font-body-bold-weight,600)!important;line-height:1.12!important;' +
        '}' +
        '.blacksmith-mobile-menu__explore-card-title{max-width:calc(100% - 20px)!important;}' +
        '.blacksmith-mobile-menu__explore-card-arrow{flex:0 0 auto!important;}' +
        '.blacksmith-mobile-menu__explore-panel>li:not(.parent-link-back):not(.blacksmith-mobile-menu__explore-grid-item){display:list-item!important;}' +
        '@media only screen and (max-width:380px){' +
          '.blacksmith-mobile-menu__explore-grid{gap:8px!important;}' +
          '.blacksmith-mobile-menu__explore-card{min-height:118px!important;}' +
          '.blacksmith-mobile-menu__explore-card-eyebrow{font-size:.58rem!important;}' +
          '.blacksmith-mobile-menu__explore-card-title,.blacksmith-mobile-menu__explore-card-arrow{font-size:.82rem!important;}' +
        '}' +
      '}';
    document.head.appendChild(exploreStyle);
  }

  function directChildWithClass(parent, className) {
    if (!parent) return null;
    for (var i = 0; i < parent.children.length; i += 1) {
      if (parent.children[i].classList.contains(className)) return parent.children[i];
    }
    return null;
  }

  function buildExploreCards() {
    var primaryMenu = drawer.querySelector('.mobile-menu');
    if (!primaryMenu) return;

    var exploreItem = null;
    for (var i = 0; i < primaryMenu.children.length; i += 1) {
      var item = primaryMenu.children[i];
      var details = directChildWithClass(item, 'link-container');
      if (!details || details.tagName !== 'DETAILS') continue;

      var summary = directChildWithClass(details, 'parent-link');
      var label = summary ? summary.textContent.replace(/\s+/g, ' ').trim() : '';
      if (label === 'Explore') {
        exploreItem = item;
        break;
      }
    }

    if (!exploreItem) return;

    var exploreDetails = directChildWithClass(exploreItem, 'link-container');
    var explorePanel = directChildWithClass(exploreDetails, 'sub-menu');
    if (!explorePanel) return;

    explorePanel.classList.add('blacksmith-mobile-menu__explore-panel');
    if (explorePanel.querySelector('.blacksmith-mobile-menu__explore-grid')) return;

    var gridItem = document.createElement('li');
    gridItem.className = 'blacksmith-mobile-menu__explore-grid-item';

    var grid = document.createElement('div');
    grid.className = 'blacksmith-mobile-menu__explore-grid';
    grid.setAttribute('aria-label', 'Featured guides');

    exploreCards.forEach(function (guide) {
      var card = document.createElement('a');
      card.className = 'blacksmith-mobile-menu__explore-card';
      card.href = guide.url;
      card.style.backgroundImage = 'url("' + guide.image + '")';
      card.innerHTML =
        '<span class="blacksmith-mobile-menu__explore-card-copy">' +
          '<small class="blacksmith-mobile-menu__explore-card-eyebrow">Blog</small>' +
          '<span class="blacksmith-mobile-menu__explore-card-title-row">' +
            '<strong class="blacksmith-mobile-menu__explore-card-title">' + guide.title + '</strong>' +
            '<span class="blacksmith-mobile-menu__explore-card-arrow" aria-hidden="true">&gt;</span>' +
          '</span>' +
        '</span>';
      grid.appendChild(card);
    });

    gridItem.appendChild(grid);

    var backItem = directChildWithClass(explorePanel, 'parent-link-back');
    if (backItem && backItem.nextSibling) {
      explorePanel.insertBefore(gridItem, backItem.nextSibling);
    } else {
      explorePanel.insertBefore(gridItem, explorePanel.firstChild);
    }
  }

  buildExploreCards();
  var exploreObserver = new MutationObserver(buildExploreCards);
  exploreObserver.observe(drawer, { childList: true, subtree: true });
});
